"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ordered_object_literal_1 = require("@stoplight/ordered-object-literal");

exports.KEYS = Symbol.for(ordered_object_literal_1.ORDER_KEY_ID);
var traps = {
  ownKeys: function ownKeys(target) {
    return exports.KEYS in target ? target[exports.KEYS] : Reflect.ownKeys(target);
  }
};

exports.trapAccess = function (target) {
  return new Proxy(target, traps);
};